// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --main-font-size: 16px;
    --main-title-font-size-mobile: 20px;
    --main-title-font-size-tablet: 30px;
    --main-title-font-size-desktop: 32px;

    --min-mobile-page-width: 320px;
    --mobile-page-width: 500px;
    --tablets-page-width: 700px;
    --desktop-page-width: 800px;

    --header-height: 60px;
    --footer-height: 50px;
    --container-padding-horizontal: 10px;
    --anchor-scroll-offset: calc(var(--header-height) + 10px);

    --section-margin-bottom: 30px;

    /* colors */
    --white: #ffffff;
    --black: #000000;
    --text: #333333;
    --grey-lightest: #fafafa;
}
`, "",{"version":3,"sources":["webpack://./../../shared/styles/variables.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,mCAAmC;IACnC,oCAAoC;;IAEpC,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;;IAE3B,qBAAqB;IACrB,qBAAqB;IACrB,oCAAoC;IACpC,yDAAyD;;IAEzD,6BAA6B;;IAE7B,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,wBAAwB;AAC5B","sourcesContent":[":root {\n    --main-font-size: 16px;\n    --main-title-font-size-mobile: 20px;\n    --main-title-font-size-tablet: 30px;\n    --main-title-font-size-desktop: 32px;\n\n    --min-mobile-page-width: 320px;\n    --mobile-page-width: 500px;\n    --tablets-page-width: 700px;\n    --desktop-page-width: 800px;\n\n    --header-height: 60px;\n    --footer-height: 50px;\n    --container-padding-horizontal: 10px;\n    --anchor-scroll-offset: calc(var(--header-height) + 10px);\n\n    --section-margin-bottom: 30px;\n\n    /* colors */\n    --white: #ffffff;\n    --black: #000000;\n    --text: #333333;\n    --grey-lightest: #fafafa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
